export default __webpack_public_path__ + "static/media/6N5A3838_tn.59471c78.jpg";